module.exports = __webpack_public_path__ + "img/UT0389.fc248f25.png";